import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
} from "@chakra-ui/react";
import React, { memo, useEffect, useState } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import { customerCall } from "../../../api/customer";
import ImagePreviewZoom from "../../../components/ImagePreviewZoom";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const FormInfo = memo(({ isOpen, onClose, defaultValue, idData }) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    if (idData) {
      const fetchData = async () => {
        try {
          const projectManager = await customerCall.getById(idData);
          if (projectManager) {
            setValue(projectManager || []);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }

    if (defaultValue) {
      setValue(defaultValue);
    }
  }, [idData, defaultValue]);

  const projectName = value?.wishlistDetail
    ? value?.wishlistDetail?.map((item) => item?.name).filter(Boolean)
    : null;
  // const projectType = value?.wishlistDetail
  //   ? value?.wishlistDetail
  //       ?.map((item) => item?.projectType?.name)
  //       .filter(Boolean)
  //   : null;

  let permanentAddress = value?.permanentAddress || "";
  if (value?.permanentAddressWardData) {
    permanentAddress += ", ";
    permanentAddress += value.permanentAddressWardData?.name;
  }
  if (value?.permanentAddressDistrictData) {
    permanentAddress += " - ";
    permanentAddress += value.permanentAddressDistrictData?.name;
  }
  if (value?.permanentAddressProvinceData) {
    permanentAddress += " - ";
    permanentAddress += value.permanentAddressProvinceData?.name;
  }

  let currentAddress = value?.currentAddress || "";
  if (value?.currentAddressWardData) {
    currentAddress += ", ";
    currentAddress += value.currentAddressWardData?.name;
  }
  if (value?.currentAddressDistrictData) {
    currentAddress += " - ";
    currentAddress += value.currentAddressDistrictData?.name;
  }
  if (value?.currentAddressProvinceData) {
    currentAddress += " - ";
    currentAddress += value.currentAddressProvinceData?.name;
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"625px"}
        h={"max-content"}
      >
        <Flex
          alignItems={"center"}
          p={"25px 24px 24px 24px"}
          position={"relative"}
          borderBottom={"1px solid var(--border-input-employee)"}
        >
          <Text
            color={"var(--color-header-employee)"}
            fontSize={"16px"}
            fontWeight={"600"}
          >
            Chi tết khách hàng
          </Text>
          <Box
            position={"absolute"}
            top={"24px"}
            right={"24px"}
            cursor={"pointer"}
            onClick={onClose}
          >
            <Image src={IconX} />
          </Box>
        </Flex>
        <Box p={"24px"}>
          <Text
            color={"var(--color-header-employee)"}
            fontSize={"16px"}
            fontWeight={"600"}
          >
            {value?.name}{" "}
            {value?.job ? `(${value?.job?.name || value?.job})` : null}
          </Text>
        </Box>
        <Box p={"0px 40px 24px 40px"}>
          <Box margin={"0 auto"}>
            <Flex>
              <Box flex={1}>
                {/*  */}
                <Box>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Liên hệ
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    mt={"13px"}
                    borderRadius={"8px"}
                  >
                    <Flex gap={"27px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Số điện thoại
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.phone || "-"}
                        </Text>
                      </Box>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Email
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.email || "-"}
                        </Text>
                      </Box>
                    </Flex>

                    <Flex gap={"27px"} mt={"16px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Giới tính
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.gender || "-"}
                        </Text>
                      </Box>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ngày sinh
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.dateOfBirth || "-"}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                </Box>

                {/*  */}
                <Box mt={"20px"}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Thông tin giấy tờ
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    mt={"16px"}
                    borderRadius={"8px"}
                  >
                    <Flex gap={"27px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Loại giấy tờ tuỳ thân
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.identityNumber || "-"}
                        </Text>
                      </Box>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Số CCCD hoặc hộ chiếu
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.identificationNumber || "-"}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex mt={"16px"} gap={"27px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ngày cấp
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.dateOfIdentification || "-"}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex mt={"16px"} gap={"27px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Nơi cấp
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.placeOfIdentification || "-"}
                        </Text>
                      </Box>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Địa chỉ thường trú
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {permanentAddress || "-"}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex mt={"16px"} gap={"27px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Chỗ ở hiện tại
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {currentAddress || "-"}
                        </Text>
                      </Box>
                    </Flex>

                    <Box flex={"1"} mt={4}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Ảnh CCCD mặt trước
                      </Text>
                      <Flex
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                      >
                        <Box borderRadius={"11px"} w={"100%"} h={"300px"}>
                          {value?.idCardFrontImage && (
                            // <Image
                            //   borderRadius={"11px"}
                            //   w={"100%"}
                            //   h={"100%"}
                            //   objectFit={"contain"}
                            //   src={`${baseURL}/${value.idCardFrontImage}`}
                            // />
                            <ImagePreviewZoom
                              src={`${baseURL}/${value.idCardFrontImage}`}
                              alt={`Ảnh CCCD mặt trước`}
                              previewTitle={`Ảnh CCCD mặt trước`}
                            >
                              <Image
                                borderRadius={"11px"}
                                w={"100%"}
                                h={"100%"}
                                objectFit={"contain"}
                                src={`${baseURL}/${value.idCardFrontImage}`}
                              />
                            </ImagePreviewZoom>
                          )}
                        </Box>
                      </Flex>
                    </Box>

                    <Box flex={"1"} mt={4}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Ảnh CCCD mặt sau
                      </Text>
                      <Flex
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                      >
                        <Box borderRadius={"11px"} w={"100%"} h={"300px"}>
                          {value?.idCardBackImage && (
                            // <Image
                            //   borderRadius={"11px"}
                            //   w={"100%"}
                            //   h={"100%"}
                            //   objectFit={"contain"}
                            //   src={`${baseURL}/${value.idCardBackImage}`}
                            // />
                            <ImagePreviewZoom
                              src={`${baseURL}/${value.idCardBackImage}`}
                              alt={`Ảnh CCCD mặt sau`}
                              previewTitle={`Ảnh CCCD mặt sau`}
                            >
                              <Image
                                borderRadius={"11px"}
                                w={"100%"}
                                h={"100%"}
                                objectFit={"contain"}
                                src={`${baseURL}/${value.idCardBackImage}`}
                              />
                            </ImagePreviewZoom>
                          )}
                        </Box>
                      </Flex>
                    </Box>

                    <Box flex={"1"} mt={4}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Ảnh VNID
                      </Text>
                      <Flex
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                      >
                        <Box borderRadius={"11px"} w={"100%"} h={"300px"}>
                          {value?.vnidImage && (
                            // <Image
                            //   borderRadius={"11px"}
                            //   w={"100%"}
                            //   h={"100%"}
                            //   objectFit={"contain"}
                            //   src={`${baseURL}/${value.vnidImage}`}
                            // />
                            <ImagePreviewZoom
                              src={`${baseURL}/${value.vnidImage}`}
                              alt={`Ảnh VNID`}
                              previewTitle={`Ảnh VNID`}
                            >
                              <Image
                                borderRadius={"11px"}
                                w={"100%"}
                                h={"100%"}
                                objectFit={"contain"}
                                src={`${baseURL}/${value.vnidImage}`}
                              />
                            </ImagePreviewZoom>
                          )}
                        </Box>
                      </Flex>
                    </Box>
                  </Box>
                </Box>

                {/*  */}
                <Box mt={"20px"}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Phân loại
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    mt={"16px"}
                    borderRadius={"8px"}
                  >
                    <Flex gap={"27px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Phân loại Khách hàng
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.customerType?.name ||
                            value?.customerType ||
                            "-"}
                        </Text>
                      </Box>
                      {projectName && projectName?.length > 0 && (
                        <Box flex={"1"}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Dự án quan tâm
                          </Text>
                          <Text
                            color={"var(--color-option-employee)"}
                            fontSize={"14px"}
                            fontWeight={"500"}
                            mt={"8px"}
                          >
                            {projectName.join(", ")}
                          </Text>
                        </Box>
                      )}
                    </Flex>
                  </Box>
                </Box>

                {/*  */}
                <Box mt={"20px"}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Thông tin thanh toán
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    mt={"16px"}
                    borderRadius={"8px"}
                  >
                    <Flex gap={"27px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Số tài khoản
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.bankAccount || "-"}
                        </Text>
                      </Box>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Tên ngân hàng
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.bankName || "-"}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex gap={"27px"} mt={"16px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Chủ tài khoản ngân hàng
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.nameAccount || "-"}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                </Box>

                {/*  */}
                <Box mt={"20px"}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Thông tin nhân viên tạo
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    mt={"16px"}
                    borderRadius={"8px"}
                  >
                    <Flex gap={"27px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Họ tên
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.employee?.fullName || value?.employee || "-"}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex gap={"27px"} mt={"16px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Khối
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.employee?.saleBlock?.name ||
                            value?.saleBlock ||
                            "-"}
                        </Text>
                      </Box>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Vùng
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.employee?.saleArea?.name ||
                            value?.saleArea ||
                            "-"}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                </Box>
              </Box>
            </Flex>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
});

export default FormInfo;
